import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getCurrencySymbol(currency: string): string {
  const currencySymbols: Record<string, string> = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    JPY: '¥',
    ALL: 'Lek',
  }
  return currencySymbols[currency] || currency
}

export function getAuthHeader(): Record<string, string> {
  const token = localStorage.getItem("access_token")
  if (!token) {
    console.error("No access token found in local storage");
  }
  return {
    'Authorization': `Bearer ${token}`,
  }
}

